import { render, staticRenderFns } from "./ModalTutor.vue?vue&type=template&id=55b4fba4"
import script from "./ModalTutor.vue?vue&type=script&lang=js"
export * from "./ModalTutor.vue?vue&type=script&lang=js"
import style0 from "./ModalTutor.vue?vue&type=style&index=0&id=55b4fba4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports